import { useRef } from 'react';
import { driver } from "driver.js";
import "driver.js/dist/driver.css";

export function useTour(steps) {
  const driverRef = useRef(null);

  const startTour = () => {
    if (driverRef.current) driverRef.current.destroy();

    driverRef.current = driver({
      showProgress: true,
      allowClose: true,
      overlayColor: "rgba(0,0,0,.6)",
      nextBtnText: "Next",
      prevBtnText: "Back",
      doneBtnText: "Done",
      steps, 
    });
    driverRef.current.drive(); 
  };

  return [startTour];
}
